import moment from "moment";
import React, { useEffect, useState } from "react";
import { BsFillCheckCircleFill, BsFillXCircleFill } from "react-icons/bs";
import {
  Badge,
  Button,
  Card,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { profilePicValidityCheck } from "../../../utils/constants";
import parse from "html-react-parser";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import awardIcon from "../../../assets/awardIcon.svg";
import { FaCrown } from "react-icons/fa";
import { isMobile } from "../../../utils/deviceInfo";
import { showAsAnonymous, showYou } from "../data";
import { GiOpenTreasureChest } from "react-icons/gi";

export default function RewardsModalDetails({
  open,
  onClose,
  data,
  updateDataInRow,
  user,
  openEditRewardModal,
  ...props
}) {
  const [showTopWinners, setShowTopWinners] = useState(false);
  const [showTopWinnersLoading, setShowTopWinnersLoading] = useState(false);
  const [rewardWinners, setRewardWinners] = useState(data.rewardWinners || []);

  const isAdmin = user ?
  user.profile.orgAdmin ||
  user.profile.role == "Admin":false;

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "";
    const n =
      firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
    return n;
  };

  const apiCallToComputeRewardWinners = () => {
    setShowTopWinnersLoading(true);

    const payload = {
      linkedTriviasIds: data.linkedTrivias.map((x) => x.triviaId),
      rewardId: data._id,
      rewardCreatedOn: data.createdOn,
      rewardEndDate: data.rewardDate,
    };

    axios
      .post(url.computeRewardsTopWinners, payload)
      .then((res) => {
        const winners = res.data.data;
        setShowTopWinnersLoading(false);
        setRewardWinners(winners);
        updateDataInRow(data._id, "rewardWinners", winners);
      })
      .catch((err) => {
        setShowTopWinnersLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (data) {
      const currentDate = moment().startOf("day");

      const rewardDate = moment(data.rewardDate).startOf("day");

      if (currentDate.diff(rewardDate, "days") >= 0) {
        if (data.rewardWinners && data.rewardWinners.length > 0) {
          setRewardWinners(data.rewardWinners);
          setShowTopWinners(true);
        } else {
          setShowTopWinners(true);
          apiCallToComputeRewardWinners();
        }
      } else {
        //nothing
      }
    }
  }, []);

  const checkUerImage = (e) => {
    if (
      e.userProfilePic &&
      e.userProfilePic != null &&
      e.userProfilePic != "null" &&
      e.userProfilePic != "undefined" &&
      e.userProfilePic != undefined
    ) {
      return true;
    }
    return false;
  };

  const modifyUrlString = (url) => {
    let lastPart = url.split("/").pop();

    // Use a regular expression to remove numbers and any file extension after a dot
    let lettersOnly = lastPart.replace(/[0-9]+-|\.[^.\s]+$/g, "");

    // Decode the URI component to convert '%20' to spaces, etc.
    let decodedString = decodeURI(lettersOnly).replace(/-/g, " ");

    if (decodedString.length > 22) {
      decodedString = decodedString.slice(0, 22) + "...";
    }

    return decodedString;
  };

  let { linkedTrivias } = data;

  console.log("rewardWinners ---- ", data.rewardDate);
  console.log("showTopWinners ---- ", showTopWinners);

  const dayText =
    moment(data.rewardDate).diff(moment(), "days") == 0
      ? "Today"
      : moment(data.rewardDate).diff(moment(), "days") > 1
      ? "days"
      : "day";

  return (
    <Modal
      className="trivia_modal_header_bg"
      isOpen={open}
      className="trivvy-modal-component-container"
    >
      <ModalHeader toggle={onClose}>
        {data.rewardName ? data.rewardName : "Reward Details"}
      </ModalHeader>
      <ModalBody className={"p-4 trivia-reward-details-modal"}>
        <Row className={"my-2 pl-1 h-fix"}>
          <Col sm={2} className="text-left">
            <b>Reward</b>
          </Col>
          <Col sm={8} className="text-left">
            {data.rewardText}
          </Col>
          <Col sm={2} className="text-right">
            {moment().isSameOrBefore(moment(data.rewardDate)) ? (
             <Button className="trivia-action-button-main add-reward-btn" onClick={()=> openEditRewardModal(data) }>Edit  <GiOpenTreasureChest /></Button>
            ) : (
              ""
            )}
          </Col>
        </Row>
        <Card className={"p-3"}>
          <Row>
            {/* <Col md={4}>
              <Row className={"my-2 h-fix"}>
                <Col sm={5} className="text-left">
                  <b>Trivvy name</b>
                </Col>
                <Col sm={7} className="text-left">
                  {data.rewardName ? data.rewardName : "Reward Details"}
                </Col>
              </Row>
              
            </Col> */}

            <Col md={12}>
              <Row className={"my-2 h-fix"}>
                <Col sm={3} className="text-left">
                  <b>Status</b>
                </Col>
                <Col sm={9} className="text-left">
                  {moment().isSameOrBefore(moment(data.rewardDate)) ? (
                    <Badge color="success">In Progress</Badge>
                  ) : (
                    <Badge color={"secondary"}>Closed</Badge>
                  )}
                </Col>
              </Row>
            </Col>
            <Col md={12}>
              <Row className={"my-2 h-fix"}>
                <Col sm={3} className="text-left">
                  <b>Ends</b>
                </Col>
                <Col sm={9} className="text-left">
                  {moment().isSameOrBefore(moment(data.rewardDate)) ? (
                    <span>
                      {moment(data.rewardDate).format("MMM D, YYYY")} (in{" "}
                      {moment(data.rewardDate).diff(moment(), "days")} {dayText}
                      )
                    </span>
                  ) : (
                    <span>
                      {/* <Badge color={"secondary"}>Closed</Badge> */}
                      <div>
                        Closed on{" "}
                        {moment(data.rewardDate).format("MMM D, YYYY")}
                      </div>
                    </span>
                  )}
                </Col>
              </Row>
            </Col>

            <Col md={12}>
              <Row className={"my-2 h-fix"}>
                <Col sm={3} className="text-left">
                  <b>Number of Trivvy Rounds</b>
                </Col>
                <Col sm={9} className="text-left">
                  {data.totalRoundsOfTrivia} rounds
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>

        {showTopWinners ? (
          <div className="my-0">
            <div className="reward-winners-tbl-container-txt">
              Winners Announced
            </div>

            {showTopWinnersLoading ? (
              <div className="text-center my-3">Loading top winners ....</div>
            ) : (
              <div className="reward-winners-tbl-container">
                {rewardWinners &&
                  rewardWinners.length > 0 &&
                  rewardWinners.map((e, idx) => {
                    console.log("name of user ---- ", e);
                    // console.log(typeof e.userProfilePic,'-----undefined --- ', e.userProfilePic)
                    return (
                      <div className="trivia-top3-tbl-row">
                        <span
                          style={{
                            display: "flex",
                            gap: "0.3em",
                            flexDirection: "row",
                          }}
                        >
                          <span style={{ position: "relative" }}>
                            {idx == 0 ? (
                              <FaCrown
                                size={"25px"}
                                className="reward-winners-top-tbl-img"
                              />
                            ) : (
                              <img
                                src={awardIcon}
                                className="awardSpotlight reward-winners-top-tbl-img"
                              />
                            )}

                            {showAsAnonymous(user.profile, e) ? (
                              <span>
                                <span
                                  className="spotlightUserInitials"
                                  data-letters={"AU"}
                                ></span>
                              </span>
                            ) : (
                              <span>
                                {checkUerImage(e) ? (
                                  <img
                                    src={e.userProfilePic}
                                    className="spotlightImage"
                                  />
                                ) : (
                                  <span
                                    className="spotlightUserInitials"
                                    data-letters={getInitials({
                                      firstName: e.userFirstName,
                                      lastName: e.userLastName,
                                    })}
                                  ></span>
                                )}
                              </span>
                            )}

                            {/* <div className="userNameList">{`${e.userFirstName} ${e.userLastName?e.userLastName:''}`} </div>  */}
                          </span>
                          <span
                            style={{
                              fontSize: " 0.68rem",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "stretch",
                              justifyContent: "start",
                            }}
                          >
                            {showAsAnonymous(user.profile, e) ? (
                              <div className="userNameList">
                                Anonymous user
                                {idx == 0
                                  ? " (1st place)"
                                  : idx == 1
                                  ? " (2nd place)"
                                  : " (3rd place)"}
                              </div>
                            ) : (
                              <div className="userNameList">
                                {`${e.userFirstName}${
                                  e.userLastName ? " " + e.userLastName : ""
                                }`}
                                {showYou(user.profile, e) ? "(You)" : ""}

                                {idx == 0
                                  ? " (1st place)"
                                  : idx == 1
                                  ? " (2nd place)"
                                  : " (3rd place)"}
                              </div>
                            )}

                            <div
                              style={{ width: "100%", flexDirection: "revert" }}
                            >
                              {" "}
                              {Math.round(e.averagePercent)}% average
                            </div>
                            <div> {e.averageTime}s average time</div>
                          </span>
                        </span>
                      </div>
                    );
                  })}
              </div>
            )}
          </div>
        ) : (
          ""
        )}

        {linkedTrivias && linkedTrivias.length > 0 ? (
          <div className="mt-4 linked-trivia-rewards-tbl-container">
            <div>
              <Row
                className={"font-weight-bold mb-0 ml-0 mr-0 pb-2 border-bottom"}
              >
                <Col
                  xs={2}
                  sm={1}
                  className={`d-flex align-items-center ${
                    isMobile ? "px-0" : "px-3"
                  }`}
                >
                  Rounds
                </Col>
                <Col xs={3} sm={6} className="d-flex align-items-center px-3">
                  Name
                </Col>

                {/* <Col sm={3} className="d-flex align-items-center px-3">
                  Reward
                </Col> */}
                {/* <Col sm={2} className="d-flex align-items-center px-3">
                 Question count
                </Col>
                <Col sm={3} className="d-flex align-items-center px-3">
                  Source
                </Col> */}
                <Col xs={7} sm={5} className="d-flex align-items-center px-3">
                  Top 3
                </Col>
                {/* <Col sm={1} className="d-flex align-items-center px-3 justify-content-center">
                 Avg time
                </Col> */}
                {/* <Col sm={1} className="d-flex align-items-center px-3"></Col> */}
              </Row>

              {linkedTrivias.map((itm, index) => {
                if (itm && itm.triviaId) {
                  let trivia = itm.triviaId;
                  return (
                    <Row
                      key={itm.triviaId}
                      className={
                        "my-0 ml-0 mr-0 reward-trivvy-modal-trivia-tbl trivvy-hover-tbl"
                      }
                    >
                      <Col xs={2} sm={1} className={isMobile ? "px-0" : "px-3"}>
                        <b>{index + 1}</b>
                      </Col>
                      <Col xs={3} sm={6} className={isMobile ? "px-0" : "px-3"}>
                        {
                          isAdmin ?   <div className="text-info cursor-pointer" onClick={()=>{
                            props.history.push(
                              `/home/trivia/${data.organizationId}/edit/${itm.triviaId}/edit`
                            );
                          }}>{itm.triviaName}</div> :  <div>{itm.triviaName}</div>
                        }
                      
                        {data.selectWinnersManually ? (
                          <small
                            onClick={() => {
                              props.history.push(
                                `/home/trivia/${data.organizationId}/edit/${itm.triviaId}/results`
                              );
                            }}
                            className="cursor-pointer text-info"
                          >
                            Click here to select winners
                          </small>
                        ) : (
                          ""
                        )}
                      </Col>
                      {/* <Col sm={1} className={`px-3`}>
                        {trivia.questionsCount}
                      </Col>
                      <Col sm={3} className="px-3 reward-trivvy-modal-url-str">
                       {modifyUrlString(trivia.uploadUrl)}
                      </Col> */}
                      <Col
                        xs={7}
                        sm={5}
                        className={isMobile ? "pr-0 pl-3" : "px-3"}
                      >
                        {itm.topScorers && itm.topScorers.length > 0
                          ? itm.topScorers.map((e) => {
                              return (
                                <div className="trivia-top3-tbl-row">
                                  <span
                                    style={{
                                      display: "flex",
                                      gap: "0.2em",
                                      flexDirection: "row",
                                    }}
                                  >
                                    {showAsAnonymous(user.profile, e) ? (
                                      <span>
                                        {" "}
                                        <span
                                          className="spotlightUserInitials"
                                          data-letters={getInitials({
                                            firstName: "Anonymous",
                                            lastName: "User",
                                          })}
                                        />
                                      </span>
                                    ) : (
                                      <span>
                                        {checkUerImage(e) ? (
                                          <img
                                            src={e.userProfilePic}
                                            className="spotlightImage"
                                          />
                                        ) : (
                                          <span
                                            className="spotlightUserInitials"
                                            data-letters={getInitials({
                                              firstName: e.userFirstName,
                                              lastName: e.userLastName,
                                            })}
                                          />
                                        )}
                                        {/* <div className="userNameList">{`${e.userFirstName} ${e.userLastName?e.userLastName:''}`} </div>  */}
                                      </span>
                                    )}

                                    <span
                                      style={{
                                        fontSize: " 0.68rem",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "stretch",
                                        justifyContent: "start",
                                      }}
                                    >
                                      {showAsAnonymous(user.profile, e) ? (
                                        <div className="userNameList">
                                          Anonymous user
                                        </div>
                                      ) : (
                                        <div className="userNameList">
                                          {`${e.userFirstName} ${
                                            e.userLastName ? e.userLastName : ""
                                          }`}{" "}
                                          {showYou(user.profile, e)
                                            ? "(You)"
                                            : ""}
                                        </div>
                                      )}
                                      <div
                                        style={{
                                          width: "100%",
                                          flexDirection: "revert",
                                        }}
                                      >
                                        {" "}
                                        {Math.round(e.score)} percent
                                      </div>
                                      <div> {e.duration} seconds</div>
                                    </span>
                                  </span>
                                </div>
                              );
                            })
                          : null}
                      </Col>
                    </Row>
                  );
                } else {
                  return "";
                }
              })}
            </div>
          </div>
        ) : (
          ""
        )}

        <div></div>
      </ModalBody>
    </Modal>
  );
}
